import { DialogActions, Button, Grid, Typography } from '@mui/material';
import { selectIsTokenExpire, setIsTokenExpire } from '../../features/auth/authSlice';
import { clearMsalTokens } from '../../utils/helper';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import CustomDialogWrapper from './CustomDialogWrapper/CustomDialogWrapper';

const TokenExpiredDialog = () => {
  const dispatch = useAppDispatch();
  const isTokenExpire = useAppSelector(selectIsTokenExpire);

  const handleClose = () => {
    dispatch(setIsTokenExpire(false));
    clearMsalTokens();
    window.location.href = '/login';
  };
  return (
    <CustomDialogWrapper open={isTokenExpire} onClose={handleClose} width="552px" height="352px">
      <Grid
        style={{
          width: '552px',
          height: '352px',
        }}
      >
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '15%',
            flexDirection: 'column',
          }}
        >
          <Typography
            style={{
              fontSize: 26,
              fontWeight: 700,
              lineHeight: '29.26px',
              textAlign: 'center',
              marginTop: '15px',
            }}
          >
            Session Expired
          </Typography>
          <Typography
            style={{
              fontSize: 16,
              fontWeight: 400,
              lineHeight: '19.5px',
              textAlign: 'center',
              marginTop: '15px',
            }}
          >
            Your session has expired. Please log in again to continue.
          </Typography>
        </Grid>
        <DialogActions
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            marginTop: '10%',
          }}
        >
          <Button
            onClick={handleClose}
            style={{
              color: 'white',
              width: '362px',
              height: '44px',
              marginBottom: '10px',
              fontSize: 14,
              background: '#E81C0E',
            }}
          >
            Okay
          </Button>
        </DialogActions>
      </Grid>
    </CustomDialogWrapper>
  );
};

export default TokenExpiredDialog;
